export default {"src":"/_next/static/media/warning_info_white.c7ff8731.svg","height":20,"width":20};